<template>
  <div>
    <!-- app-bar -->
    <div>
      <v-app-bar height="36px" elevation="0" class="animateBG">
        <v-img
          max-height="28px"
          contain
          src="https://ldwid-1258491808.file.myqcloud.com/ldwid.com/LDW_2020_Web_White.png"
        >
        </v-img>
      </v-app-bar>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
